import {
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-tipi-articoli-assegnati-by-mansione',
  templateUrl: './tipi-articoli-assegnati-by-mansione.component.html',
  styleUrls: ['./tipi-articoli-assegnati-by-mansione.component.scss'],
  imports: [FontAwesomeModule],
  standalone: true,
})
export class TipiArticoliAssegnatiByMansioneComponent implements OnChanges {
  private navService = inject(NavigatorService);
  private tipiArticoliService = inject(TipiArticoliService);
  @Input() idMansione: number = 0;
  @Input() listDetArtDip: any;

  listTipiArticoli: TipiArticoli[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['idMansione']) {
      const idMan = changes['idMansione'].currentValue;
      if (idMan && idMan > 0) {
        this.loadTipiArticoliByMansione();
      }
    }
  }

  loadTipiArticoliByMansione() {
    this.tipiArticoliService.listByMansione(this.idMansione).subscribe({
      next: (res) => {
        if (res != null) {
          this.listTipiArticoli = res;
        } else {
          notificaMessaggio(
            'Non sono presenti tipi articoli per la mansione',
            'warning',
          );
          this.navService.goToHome();
        }
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero tipi articoli by mansione');
      },
    });
  }

  isPresente(tipologia: number): boolean {
    //console.log('tip:' + tipologia);
    return (
      this.listDetArtDip?.filter((c: any) => c.idTipoArticolo == tipologia).length >
      0
    );
  }
}
